import { Box } from "@mui/material";
import PropTypes from "prop-types";

const ProgressBar = ({ currentIndex, maxReached, total }) => {
  const ballSize = 5;
  const segments = total || 1; // Evitar división por cero

  const greenPercent = ((maxReached + 1) / segments) * 100; // % de avance de barra
  const ballPercent = ((currentIndex + 1) / segments) * 100; // % de avance de bola

  return (
    <Box display="flex" width="100%" backgroundColor="#fefefe">
      <Box sx={{ flex: 1, position: "relative" }}>
        {/* Barra continua: gris de fondo + verde hasta greenPercent */}
        <Box
          sx={{
            width: "100%",
            height: 10,
            borderRadius: 2,
            backgroundColor: "#e0e0e0",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              width: `${greenPercent}%`,
              height: "100%",
              backgroundColor: "#4caf50",
            }}
          />
        </Box>

        {/* Bola que indica la posición actual */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: `calc(${ballPercent}% - ${ballSize / 2}px)`,
            width: ballSize,
            height: ballSize,
            backgroundColor: "white",
            borderRadius: "50%",
            transform: "translateY(-50%)",
          }}
        />
      </Box>
    </Box>
  );
};

ProgressBar.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  maxReached: PropTypes.number.isRequired, // Ultimo índice alcanzado
  total: PropTypes.number.isRequired, // Numero total de paginas
};

export default ProgressBar;
